import React, {useState} from 'react';
import 'contents/assets/scss/page/data.scss';
import Tab from '../../component/Inc/Tab';
import Upload from '../../component/Inc/Upload';
import Paging from '../../component/Inc/Paging';
import PopManageCategory from './_PopManageCategory';
import PopRegisterQuestion from './_PopRegisterQuestion';

function EasyPot() {
  const [modalManageCategory, setModalManageCategory] = useState(false);
  const [registerQuestion, setRegisterQuestion] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '검색한 문항', cnt: '45', value: 0},
    {title: '팟교재 리스트', cnt: '9898', value: 1},
    {title: '문제 오류', cnt: '53', value: 2}
  ];
  return (
    <main className="com_container p_easypot">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu4_6">이지팟 문제은행</h2>
          <div className="com_btn_wrap">
            <button
              onClick={() => {
                setRegisterQuestion(true);
              }}
              className="com_btn orange s btn_plus"
            >
              문제은행 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top sec_top">
              <div className="com_input_wrap flex_row">
                <select className="select xs">
                  <option value="학년 선택">학년 선택</option>
                </select>
                <select className="select xs">
                  <option value="과목 선택">과목 선택</option>
                </select>
                <select className="select xs wl">
                  <option value="내용 선택">내용 선택</option>
                </select>
              </div>
              <div className="com_input_wrap flex_row">
                <select className="select xs">
                  <option value="대제목 선택">대제목 선택</option>
                </select>
                <select className="select xs">
                  <option value="증제목 선택">증제목 선택</option>
                </select>
                <select className="select wl">
                  <option value="소제목 선택">소제목 선택</option>
                </select>
                <select className="select wl">
                  <option value="점수3">점수3</option>
                </select>
                <select className="select wl">
                  <option value="문항수 3">문항수 3</option>
                </select>
              </div>
              <div className="com_input_wrap flex_row">
                <select className="select xs">
                  <option value="학평이상">학평이상</option>
                </select>
                <select className="select xs">
                  <option value="유출 년도 선택">유출 년도 선택</option>
                </select>

                <div className="com_board_search">
                  <article className="search">
                    <input type="search" placeholder="단어 검색" className="input s type_search" />
                    <button className="com_btn gray ws s icon_search"></button>
                  </article>
                </div>
              </div>
              <div className="com_input_wrap flex_row">
                <div className="check_wrap">
                  <span className="com_check_box">
                    <input type="checkbox" name="chk" id="chk0" className="com_chk" />
                    <label htmlFor="chk0">체인숨김</label>
                  </span>
                  <span className="com_check_box">
                    <input type="checkbox" name="chk" id="chk1" className="com_chk" />
                    <label htmlFor="chk1">노트플라이</label>
                  </span>
                  <span className="com_check_box">
                    <input type="checkbox" name="chk" id="chk2" className="com_chk" />
                    <label htmlFor="chk2">스캔문제</label>
                  </span>
                  <span className="com_check_box">
                    <input type="checkbox" name="chk" id="chk3" className="com_chk" />
                    <label htmlFor="chk3">해설 있음</label>
                  </span>
                </div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="8%" />
                <col width="6%" />
                <col width="6%" />
                <col width="15%" />
                <col width="15%" />
                <col width="6%" />
                <col width="5%" />
              </colgroup>
              <thead>
                <tr>
                  <th>학년</th>
                  <th>과목</th>
                  <th>년도</th>
                  <th>추가내용</th>
                  <th>제목</th>
                  <th>태그</th>
                  <th>점수</th>
                  <th>코멘트</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>고1</td>
                  <td>경제</td>
                  <td>2018</td>
                  <td>
                    <div className="icon_wrap">
                      <div className="com_icon gray">체인숨김</div>
                      <div className="com_icon gray">노트플라이</div>
                      <div className="com_icon gray">스캔문제</div>
                    </div>
                  </td>
                  <td>
                    고3 2017년 수능 <br />
                    학국사 1번
                  </td>
                  <td className="td_left">
                    <p className="memo">우리역사의 형성과 고대 국가의 고조선과 여러 나라의 성립 청동기 및 철기 유1: 태그:</p>
                  </td>
                  <td>3</td>
                  <td>
                    <div className="icon_wrap s">
                      <div className="com_icon gray">답 오류</div>
                      <div className="com_icon gray">문제 오류</div>
                    </div>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>고1</td>
                      <td>사회문화</td>
                      <td>2018</td>
                      <td>
                        <div className="icon_wrap">
                          <div className="com_icon gray">체인숨김</div>
                          <div className="com_icon gray">노트플라이</div>
                          <div className="com_icon gray">스캔문제</div>
                          <div className="com_icon gray">해설있음</div>
                        </div>
                      </td>
                      <td>
                        고3 2017년 수능 <br />
                        학국사 1번
                      </td>
                      <td className="td_left">
                        <p className="memo">우리역사의 형성과 고대 국가의 고조선과 여러 나라의 성립 청동기 및 철기 유1: 태그:</p>
                      </td>
                      <td>3</td>
                      <td>
                        <div className="icon_wrap s">
                          <div className="com_icon gray">답 오류</div>
                          <div className="com_icon gray">문제 오류</div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">문제 유형</div>
            <div className="com_input_wrap flex_between">
              <div className="com_btn_wrap">
                <div className="com_icon gray">체인숨김</div>
                <div className="com_icon gray">노트플라이</div>
                <div className="com_icon gray">스캔문제</div>
                <div className="com_icon gray">해설있음</div>
              </div>
              <div className="com_btn_wrap">
                <button className="btn_edit"></button>
                <button className="btn_delete"></button>
              </div>
            </div>
            <div className="com_status_box">
              <div className="item orange">
                <p className="tit">정답률 : 78%</p>
              </div>
              <div className="item blue">
                <p className="tit">6등급</p>
              </div>
            </div>
            <div className="com_board_box">
              <div className="subject">선지 선택률</div>
              <div className="com_btn_wrap percent">
                <div className="com_btn s lightGray">
                  ① : <span className="cnt">10%</span>
                </div>
                <div className="com_btn s lightGray">
                  ② : <span className="cnt">50%</span>
                </div>
                <div className="com_btn s lightGray">
                  ③ : <span className="cnt">5%</span>
                </div>
                <div className="com_btn s lightGray">
                  ④ : <span className="cnt">10%</span>
                </div>
                <div className="com_btn s lightGray">
                  ⑤ : <span className="cnt">10%</span>
                </div>
              </div>
              <hr className="com_divider" />
              <div className="contents">
                <p className="bold">@ES1711-01 1. 1)</p>
                <p className="bold">(가) 시대에 대한 탐구 활동으로 가장 적절한 것은?</p>
                <p>
                  ① 주먹도끼의 용도를 알아본다. <br />
                  ② 철제 갑옷의 제작 기법을 살펴본다. <br />
                  ③ 금관이 출토된 고분에 대해 조사한다. <br />
                  ④ 비파형 동검의 형태적 특징을 분석한다.
                  <br />⑤ 빗살무늬 토기의 지역별 특색을 비교한다.
                </p>
                <p className="bold com_point_txt">정답: ④</p>
                <p>
                  청동기 시대의 이해 <br />
                  정답 해설: 제시된 자료는 청동기 시대의 사회 변화와 관련된 수행 평가 보고서이다. 반달 돌칼의 사용, 빈부의 격차와 계급 발생, 고인돌 축조 등을 통해 파악할 수 있다. 청동기 시대에는 비파형 동검, 거친무늬 거울 등 정동으로 된 무기와 제기를 사용하였다.
                </p>
                <p className="bold com_point_txt">오답피하기</p>
                <p>
                  청동기 시대의 이해 <br />
                  ② 우리나라에서는 청동기 시대에 이어 기원전 5세기경부터 철기 문화를 수용하였다. <br />
                  ③ 삼국 시대의 신라 고분에서는 금관이 출토되었다 <br />⑤ 신석기 시대부터 음식물의 조리와 저장을 위해 토가를 제작하였는데, 빗살무늬 토기는 한반도의 신석기 시대를 대표하는 토기이다.
                </p>
              </div>
              <hr className="com_divider" />
              <div className="com_input_upload">
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button type="button" className="btn_del_file" onClick={() => {}}></button>
                  <button type="button" className="btn_down" onClick={() => {}}></button>
                </p>
              </div>
              <hr className="com_divider" />
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon gray">답 오류</span>
                    <button className="name">김담임105 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit" />
                    <button className="btn_heart active">16</button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">오류입니다.</div>
                <div className="com_input_upload">
                  <p className="file">
                    <span className="txt">File name.pdf</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                    <button type="button" className="btn_down" onClick={() => {}}></button>
                  </p>
                </div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <div className="com_input_wrap flex_row">
                <select className="select">
                  <option value="문제 오류">문제 오류</option>
                </select>
                <div className="com_input_upload">
                  <Upload title="파일 등록" className="com_btn gray xs wl" />
                  <p className="file">
                    <span className="txt">File name.pdf</span>
                    <button type="button" className="btn_del_file" onClick={() => {}}></button>
                    <button type="button" className="btn_down" onClick={() => {}}></button>
                  </p>
                </div>
              </div>
              <div className="comment_input">
                <textarea className="textarea" placeholder="내용 입력해주세요"></textarea>
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopManageCategory open={modalManageCategory} close={() => setModalManageCategory(false)} />
      <PopRegisterQuestion open={registerQuestion} close={() => setRegisterQuestion(false)} />
    </main>
  );
}

export default EasyPot;
